export default __webpack_public_path__ + "static/media/token2.31a4d855.png";